import type { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { Carousel } from '../common';

interface LayoutCarouselProps extends PropsWithChildren {
  viewWidth: number;
  viewHeight: number;
  compact: boolean;
  slideIndex?: number;
  controlsColor?: string;
}

export function LayoutCarousel({
  viewWidth,
  viewHeight,
  compact,
  controlsColor,
  slideIndex,
  children
}: LayoutCarouselProps) {
  return (
    <Container>
      <Carousel
        slideIndex={slideIndex}
        controlsColor={controlsColor}
        viewWidth={viewWidth}
        viewHeight={viewHeight}
        compact={compact}
      >
        {children}
      </Carousel>
    </Container>
  );
}

const Container = styled.div``;
